import * as React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { LightMode, DarkMode } from "@mui/icons-material";
import { useTheme } from "../theme-provider";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const isDark = theme === "dark";

  const handleToggle = () => {
    setTheme(isDark ? "light" : "dark");
  };

  return (
    <Tooltip title={isDark ? "Switch to light mode" : "Switch to dark mode"} arrow>
      <IconButton
        onClick={handleToggle}
        size="small"
        sx={{
          color: isDark ? '#fbbf24' : '#64748b',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.04)',
            transform: 'rotate(15deg)',
          }
        }}
      >
        {isDark ? <LightMode /> : <DarkMode />}
      </IconButton>
    </Tooltip>
  );
}

export default ThemeToggle;
